<script setup lang="ts">
// "Mostrar anulados (n)" over a list of registros clínicos; nothing while the
// list has none.
const props = defineProps<{ count: number }>();

const showVoided = defineModel<boolean>({ default: false });
</script>
<template>
  <v-switch
    v-if="props.count > 0"
    v-model="showVoided"
    :label="`Mostrar anulados (${props.count})`"
    color="primary"
    density="compact"
    inset
    hide-details
    class="flex-grow-0"
  />
</template>
